import ScalarMenuProducts_vue_vue_type_script_setup_true_lang_default from "./ScalarMenuProducts.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarMenu/ScalarMenuProducts.vue
var ScalarMenuProducts_default = ScalarMenuProducts_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarMenuProducts_default as default };

//# sourceMappingURL=ScalarMenuProducts.vue.js.map